export default {
  en: {
    registerPage: {
      fillAll: "Please fill in all fields",
      passwordShort: "Password must be at least 6 characters",
      created: "Account created successfully!",
      failed: "Registration failed",
      createAccount: "Create Account",
      subtitle: "Register to monitor election results",
      fullName: "Full Name",
      namePlaceholder: "John Doe",
      creating: "Creating account...",
      haveAccount: "Already have an account?"
    }
  },
  fr: {
    registerPage: {
      fillAll: "Veuillez remplir tous les champs",
      passwordShort: "Le mot de passe doit contenir au moins 6 caractères",
      created: "Compte créé avec succès !",
      failed: "Échec de l'inscription",
      createAccount: "Créer un compte",
      subtitle: "Inscrivez-vous pour suivre les résultats des élections",
      fullName: "Nom complet",
      namePlaceholder: "Jean Dupont",
      creating: "Création du compte...",
      haveAccount: "Vous avez déjà un compte ?"
    }
  }
};
